import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-row-item',
  templateUrl: './row-item.component.html',
  styleUrls: ['./row-item.component.scss'],
})
export class RowItemComponent{
  @Input() justify: string = 'flex-start';
  constructor() { }


}
